export const version = {
    major: 4,
    minor: 6,
    patch: 7,
};
